import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * A simple wrapper that ensures field labels are always visible
 * @param {Object} props
 * @param {string} props.label - The field label
 * @param {React.ReactNode} props.children - The field component
 */
const LabeledField = ({ label, children }) => {
    return (
        <Box sx={{ mb: 3 }}>
            {label && (
                <Typography 
                    variant="body2" 
                    sx={{ 
                        mb: 0.5,
                        fontWeight: 500,
                        color: 'text.secondary',
                        fontSize: '0.875rem'
                    }}
                >
                    {label}
                </Typography>
            )}
            <Box>
                {children}
            </Box>
        </Box>
    );
};

export default LabeledField;
